// PR-F2 — staff card-surcharge config. Per-US-state policy for whether a
// buyer may pay a statement by card and the max surcharge rate that applies.
// Gated Portfolio.ManageTpsStripe. The rate is a FRACTION on the wire
// (0.03 = 3%); the page edits it as a percent and converts on save/display.
// Hooks in @/hooks/portfolioAdmin/useCardSurcharge wrap these with TanStack
// Query.

import { api } from "@/api/client";

export interface CardSurchargeConfigDto {
  stateCode: string;
  cardAllowed: boolean;
  /** Max surcharge rate as a FRACTION (e.g. 0.03 = 3%). */
  surchargeRate: number;
}

export interface UpdateCardSurchargeConfigRequest {
  cardAllowed: boolean;
  /** FRACTION; the server rejects < 0 or > 0.04. */
  surchargeRate: number;
}

export const cardSurchargeApi = {
  list: () =>
    api.get<CardSurchargeConfigDto[]>(`/portfolio-admin/card-surcharge`),
  update: (stateCode: string, body: UpdateCardSurchargeConfigRequest) =>
    api.put<CardSurchargeConfigDto>(
      `/portfolio-admin/card-surcharge/${encodeURIComponent(stateCode)}`,
      body,
    ),
};
